import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { IconProps } from '@chakra-ui/icons';

export const Logo: React.FC<IconProps> = ({ ...props }) => {
  return null;
};
